var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimer2Line = function SvgTimer2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 3c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9m0 16.2c3.978 0 7.2-3.222 7.2-7.2s-3.222-7.2-7.2-7.2A7.2 7.2 0 0 0 5.3 12c0 3.978 3.222 7.2 7.2 7.2m3.182-11.655 1.273 1.273-4.455 4.455L11.227 12z"
  })));
};
export default SvgTimer2Line;